import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX } = FiIcons;

const QuizModal = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-brand-blue/80 backdrop-blur-md"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative bg-white w-full max-w-4xl max-h-[90vh] rounded-[2.5rem] shadow-2xl overflow-hidden border border-brand-gold/30"
          >
            <div className="sticky top-0 z-10 bg-white border-b border-brand-silver/10 p-6 flex justify-between items-center">
              <div className="flex items-center space-x-3">
                <img src="https://i.imghippo.com/files/DqZX5957Q.png" alt="Logo" className="h-8 w-auto" />
                <span className="font-black text-brand-blue uppercase tracking-widest text-xs">Candidatura Immobile</span>
              </div>
              <button 
                onClick={onClose}
                className="p-2 hover:bg-brand-blue/5 rounded-full transition-colors text-brand-blue"
              >
                <SafeIcon icon={FiX} className="h-6 w-6" />
              </button>
            </div>
            
            <div className="overflow-y-auto p-4 md:p-8" style={{ height: 'calc(90vh - 80px)' }}>
              <iframe 
                src="https://api.leadconnectorhq.com/widget/quiz/7jFeBLezJlMSlrpQJhrc" 
                style={{ border: 'none', width: '100%', minHeight: '600px' }} 
                scrolling="no" 
                id="7jFeBLezJlMSlrpQJhrc" 
                title="quiz"
              ></iframe>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default QuizModal;